import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { QUESTION_LIST, QUESTION_DETAILS, QuestionContext, CommonContext } from './../constant/ActionTypes';
import { questionReducer } from './../reducer/questionReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    questionList: [],
    questionDetails: {}
}

const QuestionProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [questionState, dispatch] = useReducer(questionReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    // get question list
    const getQuestionList = (module_id, page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`QuestionService/getAll/module/${module_id}${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearQuestionList = () => {
        dispatch({
            type: QUESTION_LIST,
            payload: []
        });
    }

    // get question list
    const getQuestionDetails = (ques_id) => {
        api({ contentType: true, auth: true }).get(`QuestionService/getDetails/${ques_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // edit question details
    const updateQuestionDetails = (question_id, question, options, reason , url, module_id) => {
        setShowLoader(true);
        let data = {
            id : question_id,
            question,
            options,
            url,
            reason
        }
        api({ contentType: true, auth: true }).patch('QuestionService/update',data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getQuestionList(module_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Question updated successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be updated');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be updated');
            }
        });
    }

    // add Question
    const addQuestion = (question, options, reason , url, module_id) => {
        setShowLoader(true);
        let data = {
            module_id,
            question,
            options,
            url,
            reason,
        }
        api({ contentType: true, auth: true }).post('QuestionService/add',data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getQuestionList(module_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Question added successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be added');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be added');
            }
        });
    }

    //delete question
    const deleteQuestion= (question_id,module_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`QuestionService/delete/${question_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getQuestionList(module_id, 1, 25);
                commonContext.handleSnackbar(true, 'success', 'Question deleted successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be deleted');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Question cannot be deleted');
            }
        });
    }

    return (
        < QuestionContext.Provider
            value={{
                ...questionState,
                getQuestionList: getQuestionList,
                deleteQuestion: deleteQuestion,
                addQuestion: addQuestion,
                getQuestionDetails: getQuestionDetails,
                updateQuestionDetails: updateQuestionDetails,
                clearQuestionList: clearQuestionList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </QuestionContext.Provider>
    );
}

export default QuestionProvider;



// WEBPACK FOOTER //
// ./contexts/provider/QuestionContext.js